import { render, staticRenderFns } from "./VehicleTypeEditLocale.vue?vue&type=template&id=5d47ceee&"
import script from "./VehicleTypeEditLocale.vue?vue&type=script&lang=ts&"
export * from "./VehicleTypeEditLocale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports